export const rooms = [

  {
    name: "Attic",

    objects: [
      "dust",
      "wooden chest",
      "boxes",
      "rafters",
      "cobwebs",
      "bird nest",
      "bats",
      "war medals",
      "sword",
      "armour",
      "lantern",
      "rocking chair",
      "trunk",
      "old portrait",
      "candlestick",
      "moth-eaten curtain",
      "diary",
      "clock",
      "cockroach"
    ],

    concepts: [
      "gloomy",
      "forgotten",
      "spooky",
      "quiet",
      "nostalgia",
      "decay"
    ]
  },

  {
    name: "Bathroom",

    objects: [
      "sink",
      "mirror",
      "bath",
      "toothbrush",
      "soap",
      "shower",
      "cleaning spray",
      "towel",
      "razor",
      "hairdryer",
      "steam",
      "toilet",
      "perfume bottle",
      "medicine cabinet",
      "plunger",
      "bath mat",
      "rubber duck",
      "drain",
      "tap"
    ],

    concepts: [
      "cleanliness",
      "hygiene",
      "reflection",
      "sterile",
      "image",
      "purity"
    ]
  },

  {
    name: "Cellar",

    objects: [
      "wine barrel",
      "worms",
      "roots",
      "damp soil",
      "rocks",
      "clay",
      "chains",
      "shovel",
      "rusted cage",
      "skeleton",
      "mould",
      "candle",
      "pickaxe",
      "crate",
      "padlock",
      "dripping pipe",
      "coal"
    ],

    concepts: [
      "hidden",
      "death",
      "secrecy",
      "burial",
      "resistance",
      "decay"
    ]
  },

  {
    name: "Dining Room",

    objects: [
      "candle",
      "mahogany table",
      "silverware",
      "wine glass",
      "crockery",
      "dinner plate",
      "fruit bowl",
      "napkin",
      "chandelier",
      "roast chicken",
      "serving tray",
      "salt shaker",
      "pepper grinder",
      "vase",
      "chair",
      "tablecloth",
      "dessert trolley"
    ],

    concepts: [
      "luxury",
      "conversation",
      "hospitality",
      "greed",
      "celebration",
      "wealth"
    ]
  },

  {
    name: "Entrance Hall",

    objects: [
      "marble staircase",
      "hat stand",
      "coat rack",
      "umbrella stand",
      "birdcage",
      "grandfather clock",
      "mirror",
      "mail table",
      "gold-framed portrait",
      "chandelier",
      "velvet runner",
      "lantern",
      "vase of roses",
      "doormat",
      "bronze statue",
      "shoe rack",
      "antique key"
    ],

    concepts: [
      "arrival",
      "welcome",
      "status",
      "warmth",
      "transition",
      "appearance"
    ]
  },

  {
    name: "Family Room",

    objects: [
      "television",
      "couch",
      "coffee table",
      "cushion",
      "vase",
      "fruit bowl",
      "board game",
      "ottoman",
      "chess board",
      "remote control",
      "lamp",
      "fireplace",
      "photo frame",
      "rug",
      "blanket",
      "video game console",
      "speaker"
    ],

    concepts: [
      "family",
      "comfort",
      "home",
      "relaxation",
      "entertainment",
      "belonging"
    ]
  },

  {
    name: "Garage",

    objects: [
      "car",
      "bike",
      "boat",
      "oil can",
      "tyre",
      "pump",
      "canoe",
      "trailer",
      "toolbox",
      "workbench",
      "helmet",
      "battery",
      "fuel container",
      "motorbike",
      "roller door",
      "jack",
      "spanner"
    ],

    concepts: [
      "travel",
      "movement",
      "speed",
      "repair",
      "transport",
      "mechanics"
    ]
  },

  {
    name: "Hallway",

    objects: [
      "portraits",
      "doors",
      "lampshade",
      "wallpaper",
      "runner rug",
      "room numbers",
      "window",
      "coat hooks",
      "ceiling light",
      "bench",
      "painting",
      "clock",
      "archway",
      "vase"
    ],

    concepts: [
      "transition",
      "history",
      "movement",
      "connection",
      "navigation"
    ]
  },

  {
    name: "Imaginarium",

    objects: [
      "dragon",
      "wizard",
      "witch",
      "cauldron",
      "alien",
      "unicorn",
      "wand",
      "medusa",
      "minotaur",
      "Zeus",
      "test tube",
      "beaker",
      "spell book",
      "portal",
      "robot",
      "crystal ball",
      "phoenix",
      "lightning orb",
      "floating staircase"
    ],

    concepts: [
      "magic",
      "science",
      "imagination",
      "myth",
      "mystery",
      "fantasy"
    ]
  },

  {
    name: "Jewelry Box",

    objects: [
      "ring",
      "necklace",
      "brooch",
      "pendant",
      "earrings",
      "watch",
      "gems",
      "gold coin",
      "silver bracelet",
      "crown",
      "ruby",
      "emerald",
      "diamond",
      "velvet lining",
      "locket",
      "treasure key"
    ],

    concepts: [
      "wealth",
      "luxury",
      "beauty",
      "status",
      "opulence"
    ]
  },

  {
    name: "Kitchen",

    objects: [
      "knife",
      "spoon",
      "pot",
      "pan",
      "oven",
      "stove",
      "refrigerator",
      "microwave",
      "blender",
      "toaster",
      "kettle",
      "cutting board",
      "chef hat",
      "sink",
      "dishwasher",
      "spice rack",
      "freezer",
      "bread loaf",
      "fruit basket"
    ],

    concepts: [
      "food",
      "creation",
      "hunger",
      "warmth",
      "smell",
      "bustle"
    ]
  },

  {
    name: "Laundry",

    objects: [
      "washing machine",
      "basket",
      "detergent",
      "deep sink",
      "mop",
      "clothes",
      "dryer",
      "iron",
      "ironing board",
      "peg basket",
      "bleach",
      "shirt",
      "sock pile",
      "laundry hamper",
      "fabric softener"
    ],

    concepts: [
      "order",
      "cleanliness",
      "labour",
      "routine",
      "maintenance"
    ]
  },

  {
    name: "Music Room",

    objects: [
      "piano",
      "drum",
      "violin",
      "saxophone",
      "stereo",
      "trumpet",
      "flute",
      "microphone",
      "harp",
      "guitar",
      "sheet music",
      "speaker",
      "metronome",
      "record player",
      "headphones",
      "tambourine"
    ],

    concepts: [
      "music",
      "creativity",
      "performance",
      "emotion",
      "art"
    ]
  },

  {
    name: "Nursery",

    objects: [
      "baby",
      "cot",
      "rocking horse",
      "teddy bear",
      "doll",
      "mobile",
      "train set",
      "clown",
      "storybook",
      "toy blocks",
      "pacifier",
      "blanket",
      "night light",
      "balloon",
      "crayons"
    ],

    concepts: [
      "innocence",
      "childhood",
      "play",
      "growth",
      "comfort"
    ]
  },

  {
    name: "Orchard",

    objects: [
      "apple",
      "orange",
      "plum",
      "grapes",
      "tree",
      "snake",
      "picnic basket",
      "ladder",
      "watering can",
      "beehive",
      "scarecrow",
      "wheelbarrow",
      "fallen leaves",
      "branch",
      "peach"
    ],

    concepts: [
      "growth",
      "nature",
      "harvest",
      "sweetness",
      "fertility",
      "paradise"
    ]
  },

  {
    name: "Pantry",

    objects: [
      "spice jar",
      "vegetables",
      "meat",
      "eggs",
      "mousetrap",
      "bottle",
      "shelf",
      "flour bag",
      "canned food",
      "jar",
      "bread",
      "rice sack",
      "pasta box",
      "basket",
      "pickle jar"
    ],

    concepts: [
      "preparedness",
      "storage",
      "preservation",
      "supply",
      "freshness"
    ]
  },

  {
    name: "Quiet Room",

    objects: [
      "bed",
      "pillow",
      "blanket",
      "nightstand",
      "lamp",
      "alarm clock",
      "wardrobe",
      "mirror",
      "window",
      "curtains",
      "desk",
      "chair",
      "bookshelf",
      "rug",
      "fan",
      "photo frame",
      "drawer",
      "candle"
    ],

    concepts: [
      "sleep",
      "rest",
      "refresh",
      "solitude",
      "quiet",
      "dream"
    ]
  },

  {
    name: "Recreation Room",

    objects: [
      "pool table",
      "table tennis table",
      "darts",
      "table soccer",
      "pool cue",
      "scoreboard",
      "games machine",
      "weights",
      "rowing machine",
      "arcade machine",
      "beanbag",
      "mini fridge",
      "basketball hoop",
      "treadmill",
      "boxing gloves",
      "skateboard",
      "gaming headset"
    ],

    concepts: [
      "fun",
      "leisure",
      "competition",
      "sport",
      "energy",
      "adolescence"
    ]
  },

  {
    name: "Study",

    objects: [
      "book",
      "scroll",
      "bookshelf",
      "mahogany desk",
      "plush chair",
      "fireplace",
      "calendar",
      "globe",
      "hourglass",
      "ink bottle",
      "quill",
      "typewriter",
      "map",
      "magnifying glass",
      "atlas",
      "lamp",
      "filing cabinet",
      "parchment"
    ],

    concepts: [
      "learning",
      "knowledge",
      "logic",
      "theory",
      "analysis",
      "discipline"
    ]
  },

  {
    name: "Tea Room",

    objects: [
      "teacup",
      "teapot",
      "scone",
      "tart",
      "tablecloth",
      "strainer",
      "coffee",
      "sugar cube",
      "sugar bowl",
      "biscuit",
      "china plate",
      "cake stand",
      "jam jar",
      "cream jug",
      "silver spoon",
      "tray",
      "pastry"
    ],

    concepts: [
      "refinement",
      "society",
      "conversation",
      "comfort",
      "ceremony",
      "daytime"
    ]
  },

  {
    name: "Utility Room",

    objects: [
      "hammer",
      "nail",
      "spanner",
      "pliers",
      "screw",
      "ladder",
      "wheelbarrow",
      "clippers",
      "wire",
      "rope",
      "string",
      "toolbox",
      "drill",
      "saw",
      "paint can",
      "bucket",
      "wrench",
      "gloves"
    ],

    concepts: [
      "building",
      "practicality",
      "engineering",
      "repair",
      "construction",
      "invention"
    ]
  },

  {
    name: "Viewing Deck",

    objects: [
      "sky",
      "moon",
      "stars",
      "mountain",
      "lake",
      "cloud",
      "telescope",
      "binoculars",
      "compass",
      "campfire",
      "wooden railing",
      "satellite dish",
      "comet",
      "constellation map",
      "flag",
      "eagle",
      "lighthouse"
    ],

    concepts: [
      "freedom",
      "distance",
      "observation",
      "science",
      "wonder",
      "exploration"
    ]
  },

  {
    name: "Wardrobe",

    objects: [
      "boots",
      "slippers",
      "jacket",
      "shirt",
      "dress",
      "skirt",
      "pants",
      "socks",
      "tie",
      "coat hanger",
      "mirror",
      "hat",
      "scarf",
      "gloves",
      "suitcase",
      "belt",
      "uniform"
    ],

    concepts: [
      "appearance",
      "identity",
      "warmth",
      "fashion",
      "presentation",
      "status"
    ]
  },

  {
    name: "Xterior",

    objects: [
      "vines",
      "bricks",
      "pipes",
      "eaves",
      "roof",
      "chimney",
      "moss",
      "flag",
      "drainpipe",
      "window shutter",
      "ivy",
      "stone wall",
      "rusted gate",
      "mailbox",
      "rain gutter",
      "weather vane",
      "cracked pavement"
    ],

    concepts: [
      "weather",
      "cold",
      "wear and tear",
      "exposure",
      "facade",
      "age"
    ]
  },

  {
    name: "Yoga Room",

    objects: [
      "exercise ball",
      "mat",
      "incense",
      "shrine",
      "flowers",
      "fruit",
      "perfume",
      "smoke",
      "candle",
      "statue",
      "singing bowl",
      "prayer beads",
      "water fountain",
      "bamboo plant",
      "meditation cushion",
      "lantern",
      "essential oils"
    ],

    concepts: [
      "spirituality",
      "mindfulness",
      "balance",
      "inner peace",
      "religion",
      "meditation"
    ]
  },

  {
    name: "Zoo",

    objects: [
      "tiger",
      "lion",
      "giraffe",
      "rhino",
      "hippo",
      "monkey",
      "parrot",
      "emu",
      "kangaroo",
      "bear",
      "shark",
      "zookeeper",
      "cage",
      "feeding bucket",
      "elephant",
      "penguin",
      "snake",
      "flamingo"
    ],

    concepts: [
      "wildness",
      "diversity",
      "captivity",
      "survival",
      "nature",
      "chaos"
    ]
  }

]